// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__9JBD6","grid":"css_grid__0KFWJ"};